import { goalToMakeTimeFor, makingTimeForGoalEmojis } from "../../functions/shared/constants"
import { usePreSignupUserDataProperty } from "../UserProvider"

export const useUserMakingTimeFor = () => {
  const makingTimeFor = usePreSignupUserDataProperty('makingTimeFor')
  if (!makingTimeFor) return "getting good work done 💃 🎉"
  return `making progress on ${goalToMakeTimeFor[makingTimeFor] ? goalToMakeTimeFor[makingTimeFor] : makingTimeFor} ${makingTimeForGoalEmojis[makingTimeFor] || "💃 🎉"}`
}